import {
    AbstractControl,
    AsyncValidatorFn,
    ValidationErrors,
} from '@angular/forms';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {CarrierService} from '../services/carrier.service';

export class CompanyNameValidator {
    static createValidator(carrierService: CarrierService, id: number): AsyncValidatorFn {
        return (control: AbstractControl): Observable<ValidationErrors> => {
            return carrierService
                .isCompanyExists(control.value,id)
                .pipe(
                    map((result: boolean) =>
                        result ? { companyexists: true } : null
                    )
                );
        };
    }
}
